import React, { useEffect, useState } from "react"
import { Button, Tooltip } from "antd"
import { EyeOutlined, LogoutOutlined } from "@ant-design/icons"
import i18n from "../../services/i18n"

// 334-xabar (bug): kuzatuv rejimi FAQAT "Системы партнёров" sahifasida ko'rinardi —
// boshqa bo'limga o'tilgach chiqish tugmasi yo'qolib, admin begona tizim ma'lumotida
// qolib ketardi. Endi bu chiziq LAYOUT ichida: har sahifada, header ostida turadi.
//
// Manba — localStorage("tenantView"): so'rov sarlavhasini (X-Tenant-View) config.ts
// o'sha kalitdan oladi, shuning uchun kalitni o'chirish = rejimdan chiqish.
export const TENANT_VIEW_KEY = "tenantView"
export const TENANT_VIEW_NAME_KEY = "tenantViewName"
/// Boshqa komponent rejimni yoqqanda chiziq darhol yangilanishi uchun
export const TENANT_VIEW_EVENT = "tenant-view-changed"

const read = () => {
  try {
    const id = localStorage.getItem(TENANT_VIEW_KEY)
    if (!id || Number(id) <= 0) return null
    return { id, name: localStorage.getItem(TENANT_VIEW_NAME_KEY) || `№${id}` }
  } catch {
    return null
  }
}

export default function TenantViewBar() {
  const [view, setView] = useState(read)

  useEffect(() => {
    const sync = () => setView(read())
    // storage — boshqa tab; custom event — shu tab ichidagi o'zgarish
    window.addEventListener("storage", sync)
    window.addEventListener(TENANT_VIEW_EVENT, sync)
    return () => {
      window.removeEventListener("storage", sync)
      window.removeEventListener(TENANT_VIEW_EVENT, sync)
    }
  }, [])

  if (!view) return null

  const exit = () => {
    try {
      localStorage.removeItem(TENANT_VIEW_KEY)
      localStorage.removeItem(TENANT_VIEW_NAME_KEY)
    } catch {}
    // Sahifadagi ma'lumot begona tizimniki — o'z tizimiga qaytish uchun qayta yuklanadi
    window.location.reload()
  }

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 900, // drawer (1000) va modaldan (1050) PAST — ularni to'sib qo'ymaydi
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "7px 16px",
        background: "#fff7e6",
        borderBottom: "1px solid #ffd591",
        color: "#874d00",
        fontSize: 13,
        lineHeight: 1.3,
      }}
    >
      <EyeOutlined style={{ fontSize: 15 }} />
      <span style={{ flex: 1, minWidth: 0 }}>
        Режим наблюдения:{" "}
        <b style={{ color: "#ad4e00" }}>{view.name}</b> — вы видите данные этой системы, а не свои.
      </span>
      <Tooltip title={i18n.t("backToOwnData")}>
        <Button size="small" type="primary" danger icon={<LogoutOutlined />} onClick={exit}>
          Выйти из режима
        </Button>
      </Tooltip>
    </div>
  )
}
